<template>
  <input
    class="m-input"
    :class="{ warning, danger, 'read-only': readonly, disabled }"
    type="text"
    :placeholder="placeholder"
    :readonly="readonly"
    v-model="localData"
    @change="emits('focus', $event)"
    @focus="emits('focus', $event)"
    @blur="emits('blur', $event)"
    @keydown="emits('keydown', $event)"
    @click="emits('click', $event)" />
</template>

<script setup lang="ts">
import { computed, withDefaults } from "vue";

const props = withDefaults(
  defineProps<{
    value?: string;
    placeholder?: string;
    readonly?: boolean;
    disabled?: boolean;
    warning?: boolean;
    danger?: boolean;
    lazy?: boolean;
  }>(),
  {}
);
const emits = defineEmits(["input", "change", "focus", "blur", "keydown", "click"]);

const localData = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});
</script>
